/**
 * AlmadarPostWhyStateMachinesForBusinessENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostWhyStateMachinesForBusinessENPostPage
 */

import { useAlmadarPostWhyStateMachinesForBusinessENPostPageLogic } from '@/hooks/traits/useAlmadarPostWhyStateMachinesForBusinessENPostPageLogic';
import type { AlmadarPostWhyStateMachinesForBusinessENPostPageConfig } from '@/hooks/traits/useAlmadarPostWhyStateMachinesForBusinessENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostWhyStateMachinesForBusinessENPostView as AlmadarPostWhyStateMachinesForBusinessENPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { AlmadarPostWhyStateMachinesForBusinessENPostHeaderView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessENPostHeaderView';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostWhyStateMachinesForBusinessENPostFooterView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessENPostFooterView';
import { AlmadarPostWhyStateMachinesForBusinessENPostView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessENPostView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostWhyStateMachinesForBusinessENPostPageViewProps {
  config?: Partial<AlmadarPostWhyStateMachinesForBusinessENPostPageConfig>;
}

export function AlmadarPostWhyStateMachinesForBusinessENPostPageView({ config: propsConfig }: AlmadarPostWhyStateMachinesForBusinessENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostWhyStateMachinesForBusinessENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostWhyStateMachinesForBusinessENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostWhyStateMachinesForBusinessEN" trait="AlmadarPostWhyStateMachinesForBusinessENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostWhyStateMachinesForBusinessENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><AlmadarPostWhyStateMachinesForBusinessENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} paddingY="xl" bg="transparent"><Container size="xl" padding="lg" maxWidth="xl"><AlmadarPostWhyStateMachinesForBusinessENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostWhyStateMachinesForBusinessENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostWhyStateMachinesForBusinessENPostPageView;
